import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useUFOReportError } from '@atlaskit/react-ufo/report-error';
import { fireErrorAnalytics } from '@atlassian/error-handling';
var isFetchClientError = function isFetchClientError(err) {
  return (err === null || err === void 0 ? void 0 : err.status) < 500;
};
export var HubErrorBoundary = function HubErrorBoundary(_ref) {
  var children = _ref.children,
    packageName = _ref.packageName,
    id = _ref.id,
    fallback = _ref.fallback,
    shouldForceError = _ref.shouldForceError;
  var logError = useUFOReportError();
  var onError = function onError(error) {
    if (isFetchClientError(error)) {
      // skip fetch client error e.g. 4xx
      return;
    }
    // Fire additional error analytics
    try {
      // Log rUFO error metrics
      logError({
        name: error.name,
        errorMessage: error.message,
        errorStack: error.stack,
        forcedError: shouldForceError
      });
      fireErrorAnalytics({
        error: error,
        meta: {
          id: id,
          packageName: packageName
        }
      });
    } catch (err) {
      // Added to silently fail Uncaught ReferenceError: __SERVER__ is not defined
      // eslint-disable-next-line no-console
      console.warn('Failed to fire error analytics:', err);
    }
  };
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    onError: onError,
    fallback: fallback
  }, children);
};